import React, { useState, useEffect, } from 'react';
import '../../css/CareersLandingPage.css';
import DialogModal from '../../helper/Dialog';
import NewUserLogin from '../Login/LoginUser';
import FormContainer from '../Forms/FormContainer';
import Dashboard from '../Dashboard/dashboard';
import Popup from '../../helper/SuccessPopup';
import AppContext from '../../helper/Context';
import ApiGateway from '../../helper/ApiGateway';
import ERPUtils from '../../helper/Utils';
import Loader from '../../helper/Loader';
import useStateCallback from '../../helper/asyncSetState';
import ChangePassword from '../Login/changePassword';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TimerComponent from '../Login/TimerComponent';
import MaintenanceMarquee from '../MaintenanceMarquee';
import CategoryFilter from '../LandingPage/CategoryFilter';
import CareersViewPage from '../LandingPage/CareersViewPage';

const CareersLandingPage = ({ }) => {
	// let token = ERPUtils.queryString().token || '';
	const [tokenEmployee, setTokenEmployee] = useState('')
	if (ERPUtils.isNullorWhiteSpace(tokenEmployee) === false) {
		AppContext.attachMember('token', 'Bearer ' + decodeURIComponent(tokenEmployee));
	}
	let loggedIn = ERPUtils.isNullorWhiteSpace(AppContext.token) === false;
	const showCareers = ERPUtils.isNullorWhiteSpace(AppContext.token) === true;
	const [ApplicationsData, setApplicationsData] = useState([]);
	const [LoaderActive, setLoaderActive] = useState(false);
	const [ModalOpen, setModalOpen] = useState(false); // For showing Dialog Box
	const [Logged, setLogged] = useState(loggedIn || false); // For showing dropdown button after login value will be based on token.
	const [ApplSubmitPopup, setApplSubmitPopup] = useState(false);
	// const [DraftSuccess, setDraftSuccess] = useState(false);
	const [PendingApplErrorPopup, setPendingApplErrorPopup] = useStateCallback(false);
	const [CommonApisErrorPopup, setCommonApisErrorPopup] = useStateCallback(false);
	const [applicantName, setApplicantName] = useStateCallback('');
	const [LockDashboard, setLockDashboard] = useState(false);
	const [email, setEmail] = useState('');
	const [registrationId, setRegistrationId] = useState("")
	// Errors state:
	const [ErrorPopup, setErrorPopup] = useState(false);
	const [ErrorMsg, setErrorMsg] = useState('');
	const [careersPage, setCareersPage] = useState(showCareers); // For displaying Careers page Based on Login token.
	const [dashboard, setDashboard] = useState(false); // For showing Dashboard on select.
	const [FormDisplay, setFormDisplay] = useState(false); // For showing form Based on token.
	const [CallDraft, setCallDraft] = useState(false);
	const [CallDraftApplNo, setCallDraftApplNo] = useState(null);
	const [applyNew, setApplyNew] = useState(false);
	//Timer state
	const [timerRunning, setTimerRunning] = useState(false)
	const [timerReset, setTimerReset] = useState(false)
	const [timePeriodOver, setTimePeriodOver] = useState(false)
	const [timerAlert, setTimerAlert] = useState(false)
	const SuccessIcon = <i className="fa fa-check successIcon" aria-hidden="true" />; // For showing icon on popup


	const [jobCode, setJobCode] = useState("")
	const [filterPage, setFilterPage] = useState(false)
	const [categoryFilter, setCategoryFilter] = useState(false)

	const [jobAdvertisements, setJobAdvertisements] = useState([])
	const [filterAdvertisement, setFilteredAdvertisement] = useState([])
	// To open Login Dialog:
	const openModal = () => {
		setModalOpen(true);
	};


	// To close the Dialog:
	const handleClose = (e, isAfterRegister) => {
		// let token = sessionStorage.getItem("_token_employee");
		// let token = tokenEmployee
		if (isAfterRegister) {
			setCareersPage(true);
			setLogged(false);
			setModalOpen(true);
			// setFilterPage(true)
		} else {
			// setCareersPage(false);
			setLogged(false);
			// setFilterPage(fa)
			setDashboard(false);
			setModalOpen(false);
		}
		setFormDisplay(false);
	};
	const closeChangePassword = () => {
		setModalOpen(false);
	};
	// To alert the error popup:
	const AlertError = () => {
		setErrorPopup(true);
	};
	// To Display  Dashboard on select:
	const dashboardHandler = () => {
		checkApplications();
		setCareersPage(false);
		setDashboard(true)
		setFilterPage(false)
		setCallDraft(false);
		setCallDraftApplNo('');
		setApplyNew(false);
	};
	// To Display  careers page:
	const careersPageHandler = () => {
		setFormDisplay(false);
		setDashboard(false);
		setCareersPage(true);
		// navigate("/")
	};
	// To Display Popup after successful submit of form:
	const SubmitSuccess = () => {
		setApplSubmitPopup(true);
		// setTimerRunning(false)
	};
	// To close the saved Popup:
	const closePopup = () => {
		setApplSubmitPopup(!ApplSubmitPopup);
		checkApplications();
	};
	// To Display Popup on Draft Success:
	const popupOnDraftSuccess = (isValid) => {
		if (isValid) {
			toast.success("Your data has been saved in draft")
		}
		// setDraftSuccess(isValid);
	};
	// const closeDraftPopup = () => {
	// 	setDraftSuccess(!DraftSuccess);
	// 	if (LockDashboard) {
	// 		changeDashboardStatus();
	// 	}
	// };
	// To handle the Error Popup:
	const ErrorPopupHandler = () => {
		setErrorPopup(!ErrorPopup);
	};
	// To apply for new job again:
	const ApplyNewHandler = () => {
		setApplyNew(true);
		setDashboard(false);
		setFormDisplay(true);
		setCallDraft(false);
		setCallDraftApplNo("");
		// setTimerReset(true)
		// setTimerRunning(true)
	};
	//To Display form after save draft:
	const openPendingApplication = (ApplNo) => {
		setCallDraft(true);
		setCallDraftApplNo(ApplNo);
		setApplyNew(false);
		setDashboard(false);
		setFormDisplay(true);
	};
	const ApplicationLoadingError = (target, message) => {
		if (target === 'CommonApis') {
			setErrorMsg(message);
			setCommonApisErrorPopup(true);
		}
		if (target === 'SaveDraft') {
			setErrorMsg(message);
			setPendingApplErrorPopup(true);
		}
	};
	const CloseApplLoadingErrorPopup = (target) => {
		if (target === 'CommonApis') {
			setCommonApisErrorPopup(false);
		}
		if (target === 'SaveDraft') {
			setPendingApplErrorPopup(false);
			setCallDraft(false);
			setDashboard(true);
			setFormDisplay(false);
		}
	};
	const timerAlertHandler = () => {
		setTimerAlert(!timerAlert);
		setTimeout(() => LogMeOut(), 50)
	};
	// To Logout the User:
	const LogMeOut = () => {
		setTokenEmployee('')
		setApplicantName('')
		setEmail('')
		setRegistrationId(null)
		setCareersPage(true);
		setDashboard(false)
		setLogged(false)
		setFormDisplay(false)
		setCallDraft(false)
		setCallDraftApplNo("")
		setTimerRunning(false)
		setTimerReset(true)
		setApplicationsData([]);
		// navigate("/")
		sessionStorage.clear()
		AppContext.attachMember('token', '');
		AppContext.attachMember('refreshToken', '');
		setTimeout(() => {
			sessionStorage.clear()
		}, 10)
	};
	// To login the User:
	const LogMeIn = (Email, Password) => {
		let data = { loginId: Email, loginPassword: Password };
		if (ERPUtils.isNullorWhiteSpace(data.loginId)) {
			setErrorMsg('Please Enter  Valid Login Id');
			AlertError();
		} else if (ERPUtils.isNullorWhiteSpace(data.loginPassword)) {
			setErrorMsg('Please Enter  Valid Password');
			AlertError();
		} else {
			setLoaderActive(true);
			ApiGateway.post('ApplicantSecurity/AuthApplicant', data, (response) => {
				try {
					setLoaderActive(false);
					if (ERPUtils.isUndefinedOrNull(response.data) || ERPUtils.isNullorWhiteSpace(response.data.token)) {
						setErrorMsg('Could not find your account');
						AlertError();
					} else {
						setRegistrationId(response.data?.empApplicationRegistrationId)
						setTokenEmployee(response.data.token)
						sessionStorage.setItem("isApplicantLogged", true)
						sessionStorage.setItem('refreshToken', response.data.refreshToken)
						sessionStorage.setItem("registrationID", response.data.empApplicationRegistrationId)
						sessionStorage.setItem('token', response.data.token)
						AppContext.attachMember("refreshToken", response.data.refreshToken);
						AppContext.attachMember("token", 'Bearer ' + decodeURIComponent(response.data.token));

						setLogged(true)
						setDashboard(true)
						setCareersPage(false)
						setFilterPage(false)
						setTimerRunning(true)
						setModalOpen(false)

					}
				} catch (ex) {
					setLoaderActive(false);
				} finally {
					setLoaderActive(false);
				}
			}, "Public");
		}
	};
	const checkApplications = () => {
		var id = registrationId

		if (ERPUtils.isNullorWhiteSpace(id) && sessionStorage.getItem('isApplicantLogged') === 'true') {
			console.log("first")
			id = sessionStorage.getItem("registrationID")
			setLogged(true)
			setTokenEmployee(sessionStorage.getItem('token'))
			setCareersPage(false)
			setDashboard(true)
		}
		if (ERPUtils.isUndefinedOrNull(id) === false && Logged) {
			setLoaderActive(true);
			ApiGateway.post(
				"Employee/Recruitment/EmployeeApplicationControler/getEmployeeApplicationStatus",
				'',
				(response) => {
					try {
						setLoaderActive(false);
						if (ERPUtils.isUndefinedOrNull(response.data) === false) {
							if (response.data.success === false) {
								setErrorMsg(response.data.failureMessage);
								AlertError();
								setRegistrationId("")
								setCareersPage(true)
								sessionStorage.setItem("registrationID", "");
								sessionStorage.setItem('isApplicantLogged', 'false');
							} else {
								if (response.data.failureMessage === null) {
									if (ERPUtils.isUndefinedOrNull(response.data.dto) === false) {
										if (response.data.dto.length > 0) {
											setApplicantName(response.data.dto[0].applicantName);
											setApplicationsData(response.data.dto);
											setFormDisplay(false);
											setDashboard(true);
											setLockDashboard(false);
										} else if (typeof (response?.data?.dto) === "object" && ERPUtils.isNullorWhiteSpace(response.data?.applicationNo)) {
											setApplicantName(response.data?.dto?.applicantName);
											setEmail(response.data?.dto?.emailId);
											setFormDisplay(true);
											setDashboard(false);
											setApplicationsData([]);
											setLockDashboard(true);
											setApplyNew(true)
											setCallDraftApplNo(registrationId)
										}
										setTimerRunning(true)
									} else {
										setApplicantName("");
										setEmail("");
										setFormDisplay(true);
										setDashboard(false);
										setLockDashboard(true);
										setApplicationsData([]);
									}
								} else {
									setErrorMsg(response.data.failureMessage);
									AlertError();
									setApplicationsData([]);
									setDashboard(false);
									setCareersPage(true);
									setLogged(false)
									setLockDashboard(true);
								}
							}
						}
					} catch (ex) {
						setLoaderActive(false);
						setErrorMsg(response.data.failureMessage);
						AlertError();
					} finally {
						setLoaderActive(false);
					}
				}
			);
		} else if (Logged) {
			setLoaderActive(false);
			setFormDisplay(false);
			setLockDashboard(true);
		}
	};
	const getInstruction = () => {
		// const fileName = 'UserManualCareerPortal.pdf';
		const fileName = "https://prod-espro-public.s3.ap-south-1.amazonaws.com/images/manual/User Manual-Career Portal.pdf"
		// const filePath = process.env.PUBLIC_URL + '/' + fileName;
		window.open(fileName, '_blank');
		// // Create a temporary anchor element
		// const link = document.createElement('a');
		// link.href = filePath;
		// link.download = fileName;
		// // Dispatching a click event on the anchor
		// document.body.appendChild(link);
		// link.click();
		// // Clean up
		// document.body.removeChild(link);
	}



	const applyHandler = (path) => {
		if (!loggedIn) {
			openModal();
		} else {
			dashboardHandler()
		}
		setJobCode(path)
	}

	const openFilterHandler = () => {
		setFilterPage(true);
		setCareersPage(false);
		setDashboard(false)
	}

	const onBackCareersHandler = () => {
		setFilterPage(false);
		setCareersPage(true);
		setDashboard(false)
	}


	const onGetJobsAdvertisements = () => {
		setLoaderActive(true);
		ApiGateway.post("Advertisement/getAdvertisementContent", {}, (response) => {
			try {
				const data = !ERPUtils.isNullorWhiteSpace(response) ? response.data : []
				setJobAdvertisements(data)
			} catch (error) { }
			setLoaderActive(false);
		}, "Public")
	}


	const filterHandler = (value) => {
		if (!ERPUtils.isNullorWhiteSpace(value)) {
			let filtered = [];
			if (jobAdvertisements.length === 1) {
				if (!jobAdvertisements[0].isCommonAdvertisement) {
					filtered = jobAdvertisements.filter(item =>
						item.empApplnAdvertisementCategoryDTOList?.some(
							cat => cat.empEmployeeCategory?.value === value
						)
					)
				} else {
					filtered = jobAdvertisements
				}
			} else {
				filtered = jobAdvertisements.filter(item =>
					item.empApplnAdvertisementCategoryDTOList?.some(
						cat => cat.empEmployeeCategory?.value === value
					)
				)
			}
			setCategoryFilter(true)
			setFilteredAdvertisement(filtered);
		} else {
			setJobAdvertisements(jobAdvertisements);
			setCategoryFilter(false)
		}
	}


	useEffect(() => {
		onGetJobsAdvertisements();
		window.history.scrollRestoration = "manual";
	}, [])
	// UseEffect to load data from Api:
	useEffect(() => {
		checkApplications();

	}, [Logged]);
	return (
		<div className="ParentDiv">
			<div className="childDiv" style={{ height: dashboard ? "100vh" : "" }} >
				<div className="logoHeader">
					<div className="logo ">
						<img
							src='https://prod-espro-public.s3.ap-south-1.amazonaws.com/Logo/ESPro_Logos/CAREERS_LOGO.svg'
							className="logoImage" alt="Loading" style={{ background: "#0b3f64be" }} />
					</div>
					<div className='marqueClass'>
						<MaintenanceMarquee />
					</div>
					<div className='login-button-timer-wrap '>
						<div className='download-manual-button' title='Download user manual' role='button' tabIndex={0}
							onKeyDown={(e) => ERPUtils.isKeyBoardEnterPressed(e) ? getInstruction() : null}
							onClick={getInstruction}>
							<i className="far fa-question-circle " style={{ color: "#ffffff", fontSize: "1.5rem" }}></i>
						</div>
						<div className='timerCompo'>
							<TimerComponent
								timerRunning={timerRunning}
								LogMeOut={LogMeOut}
								timerReset={timerReset}
								setTimerReset={setTimerReset}
								setTimerRunning={setTimerRunning}
								setTimePeriodOver={setTimePeriodOver}
								Logged={Logged}
								setTimerAlert={setTimerAlert}
							/>

						</div>
						{Logged ? (
							<div className="dropdown" style={{ cursor: "pointer" }}>
								<button className="dropDownButton dropdown-toggle p-1" type="button" data-toggle="dropdown" style={{ marginTop: window.innerWidth < 768 ? "0px" : "30px", width: window.innerWidth < 768 ? "104px" : "150" }}>
									<span style={{ width: "110px", textOverflow: "ellipsis", overflow: "hidden", display: "inline-block" }}>
										{applicantName} &nbsp;
									</span>
									<span className="caret" />
								</button>
								<ul className="dropdown-menu dropdown-menu-right">
									<li className='p-1'>
										<div
											className='emp-appl-custom-link p-1 d-flex align-items-center'
											onClick={dashboardHandler}
											tabIndex={0}
											onKeyDown={(e) => {
												if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
													dashboardHandler()
											}
											}
										>
											<span
												className="fa fa-chart-line SpanIcon"
												style={{ marginRight: 8, fontSize: 15 }}
											/>My Dashboard
										</div>
									</li>
									<li className='p-1'>
										<div onClick={() => openModal(true)}
											className='emp-appl-custom-link p-1 d-flex align-items-center'
											tabIndex={0}
											onKeyDown={(e) => {
												if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
													openModal(true)
											}}
										>
											<span className="fa fa-key SpanIcon" style={{ marginRight: 8 }} />
											Change Password
										</div>
									</li>
									<li className='p-1'>
										<div role="button"
											// onClick={() => navigate("/careers")}
											onClick={careersPageHandler}
											className='emp-appl-custom-link p-1 d-flex align-items-center'
											tabIndex={0}
											onKeyDown={(e) => {
												if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
													careersPageHandler()
											}}>
											<span className="fa fa-suitcase SpanIcon" style={{ marginRight: 8 }} />
											Careers
										</div>
									</li>
									<li className="divider" />
									<li className='p-1'>
										<div onClick={LogMeOut}
											className='emp-appl-custom-link p-1 d-flex align-items-center'
											tabIndex={0}
											onKeyDown={(e) => {
												if ((e.key !== "Tab") && ERPUtils.isKeyBoardEnterPressed(e))
													LogMeOut()
											}}>
											<span className="fa fa-lock SpanIcon" style={{ marginRight: 8 }} />
											Logout
										</div>
									</li>
								</ul>
							</div>
						) : (

							<button className="signInButton" value="Apply Now" name="signIn" onClick={() => openModal(true)} style={{ width: window.innerWidth < 768 ? "104px" : "120px", marginTop: window.innerWidth < 768 ? "0px" : "30px", marginLeft: window.innerWidth <= 375 ? "16px" : "" }}>
								Apply / Login
							</button>
						)}


					</div>
				</div>
				<div className="careerContent mt-2" style={{ maxWidth: careersPage || filterPage ? "" : "1500px" }}>
					{careersPage ? <CareersViewPage
						jobAdvertisements={jobAdvertisements}
						filterHandler={filterHandler}
						loggedIn={Logged}
						ApplyNewHandler={ApplyNewHandler}
						onOpenFilter={openFilterHandler}
						onBackCareers={onBackCareersHandler}
						applyHandler={applyHandler}
					/> : null}
					{/* {console.log(filter)} */}
					{filterPage && (
						<CategoryFilter
							ApplyNewHandler={ApplyNewHandler}
							jobAdvertisements={!categoryFilter ? jobAdvertisements : filterAdvertisement}
							setFilter={setFilterPage} onBackCareers={onBackCareersHandler}
							applyHandler={applyHandler}
						/>
					)}


					{/* {careersPage ? <Careers loggedIn={Logged} onClick={openModal} jobAdvertisements={jobAdvertisements} /> : null} */}
					{FormDisplay ? (
						<FormContainer
							registrationId={registrationId}
							SubmitSuccess={SubmitSuccess}
							popupOnDraftSuccess={popupOnDraftSuccess}
							CallDraft={CallDraft}
							CallDraftApplNo={CallDraftApplNo}
							setCallDraft={setCallDraft}
							setCallDraftApplNo={setCallDraftApplNo}
							ApplicationLoadingError={ApplicationLoadingError}
							applyNew={applyNew}
							Email={email}
							username={applicantName}
							dashboardHandler={dashboardHandler}
							LockDashboard={LockDashboard}
							jobCode={jobCode}
							// setTimerRunning={setTimerRunning}
							timePeriodOver={timePeriodOver}
							setTimePeriodOver={setTimePeriodOver}
							LogMeOut={LogMeOut}
						/>
					) : null}
					{(dashboard && Logged) ? (
						<Dashboard
							ApplyNewHandler={ApplyNewHandler}
							openPendingApplication={openPendingApplication}
							ApplicationsPrevData={ApplicationsData}
							jobCode={jobCode}
							checkApplications={checkApplications}
						/>
					) : null}
				</div>
			</div>
			{
				ModalOpen ? Logged === false ? (
					<DialogModal
						open={ModalOpen}
						close={handleClose}
						component={<NewUserLogin LogMeIn={LogMeIn} close={handleClose} setTokenEmployee={setTokenEmployee} />}
					/>
				) : (
					<DialogModal
						open={ModalOpen}
						close={closeChangePassword}
						component={<ChangePassword close={closeChangePassword} registrationId={registrationId} Logged={Logged} LogMeOut={LogMeOut} />}
					/>
				) : null
			}
			{
				ApplSubmitPopup ? (
					<Popup
						open={ApplSubmitPopup}
						close={closePopup}
						msg="Your Application has been submitted successfully"
						title="Success"
						Success
						icon={SuccessIcon}
						success={true}
					/>
				) : null
			}
			{/* {DraftSuccess ? (
				// <Popup
				// 	open={DraftSuccess}
				// 	close={closeDraftPopup}
				// 	msg="Your data has been saved in draft"
				// 	icon={SuccessIcon}
				// 	title="Great!"
				// 	success={true}
				// />
				// <ToastAlert
				// text="Your data has been saved in draft"
				// type="success"
				// />
				// toast.success("Your data has been saved in draft")
			) : null} */}
			{
				ErrorPopup ? (
					<Popup
						open={ErrorPopup}
						close={ErrorPopupHandler}
						msg={ErrorMsg}
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						title="Sorry!"
						success={false}
					/>
				) : null
			}
			{
				PendingApplErrorPopup ? (
					<Popup
						open={PendingApplErrorPopup}
						close={CloseApplLoadingErrorPopup}
						msg={ErrorMsg}
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						hint="Note: Please try again after sometime"
						success={false}
						tabName="SaveDraft"
					/>
				) : null
			}
			{
				CommonApisErrorPopup ? (
					<Popup
						open={CommonApisErrorPopup}
						close={CloseApplLoadingErrorPopup}
						msg={ErrorMsg}
						icon={<i className="fa fa-times-circle" style={{ fontSize: '48px', color: '#D9291B' }} />}
						hint="Note: Please try again after sometime"
						success={false}
						tabName="CommonApis"
					/>
				) : null
			}
			{
				timerAlert ? (
					<Popup
						open={timerAlert}
						close={timerAlertHandler}
						msg="All your changes will be saved.
						 Please re-login to make any further changes. "
						icon={<i className="fa-solid fa-circle-info fa-xl" style={{ color: "#ede735", fontSize: '35px' }}></i>}
						title="Session Expired!"
						success={false}
					/>
				) : null
			}
			{LoaderActive ? <Loader open={LoaderActive} LoaderType={1} /> : null}
			<ToastContainer
				position="top-right"
				autoClose={2000}
				hideProgressBar
				newestOnTop
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="colored"
			/>
		</div >
	);
}
export default CareersLandingPage;